module.exports = __webpack_public_path__ + "static/img/xinwen_pic3.17c33491.jpg";